import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import AlertMessage from "../Objects/AlertMessage.js";
import Repo from "../Utility/Repo";
import ListaPagamentiEffettuati from "../Objects/ListaPagamentiEffettuati";
import moment from "moment";
import Pagination from "../Objects/Pagination.js";
import Select from "../Objects/Select.js";
import { Link } from "react-router-dom";
import useLocalStorage from "../Utility/useLocalStorage.js";

import {
  Input
} from "design-react-kit";


function PagamentiEffettuati(props) {
  const [cookies] = useCookies();
  const [apiToken] = useState(cookies.api_token);
  const [loading, setLoading] = useState();
  const [pagamentiEffettuati, setPagamentiEffettuati] = useState([]);
  const [bkEffettuati, setBkEffettuati] = useState([]);

  const [advancedFilters, setAdvancedFilters] = useState(false);

  const [responseEffettuati, setResponse, removeResponse] =
    useLocalStorage("responsePagamentiEffettuati");



  const [errorMessage, setErrorMessage] = useState(false);

  const [pageNumber, setPageNumber] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [queryCount, setQueryCount] = useState(0);
  const [entrysList, setEntrysList] = useState([
    {
      value: "0",
      label: "Tutti",
    },
  ]);

  const [data, setData] = useState({
    cfpIva: "",
    nomeUnivocoCartella: "string",
    pageIndex: 0,
    pageSize: 10,
    orderDescending: true,
    orderField: "CFPIva",
  });

  useEffect(() => {
    if (props.codiceFiscale) {
      var dataObb = data;
      dataObb.cfpIva = props.codiceFiscale;
      var dataJson = JSON.stringify(dataObb);
      setData(dataObb);



      if (responseEffettuati) {
        setFilter(responseEffettuati);
        setPagamentiEffettuati(responseEffettuati);
        setBkEffettuati(responseEffettuati)
        setLoading(true);
      } else reload(dataJson)



      // if (localStorage.getItem("dataForm")) {
      //   setData(JSON.parse(localStorage.getItem("dataForm")));
      //   dataJson = localStorage.getItem("dataForm");
      // } else {
      // }

      // reload(dataJson);
    }
  }, [props.codiceFiscale]);


  const reload = (dataJson) => {
    setLoading(false);
    localStorage.setItem("dataForm", dataJson);
    Repo.getPagamentiEffettuatiContribuente(apiToken, dataJson)
      .then((response) => {
        setPagamentiEffettuati(response.data.items ? response.data.items : []);
        setResponse(response.data.items);
        setBkEffettuati(response.data.items)
        setFilter(response.data.items);
        setLoading(true);
        setPageCount(response.data.pageCount);
        setQueryCount(response.data.queryCount);
        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
        setErrorMessage(true);
      });
  };

  const ChangePage = (numberPage) => {
    var page = numberPage - 1;
    var dataTemp = data;
    dataTemp.pageIndex = page;
    setData(dataTemp);
    setPageNumber(page);

    reload(JSON.stringify(data));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setPagamentiEffettuati(bkEffettuati);

    var temp = bkEffettuati
    if (data.dal || data.al) {
      temp = temp.filter(x => new Date(x.dataPagamento.split("T")[0]) >= new Date(data.dal) && new Date(x.dataPagamento.split("T")[0]) <= new Date(data.al))
      console.log("prova 1")
    }
    console.log('data.tipoCartella: ', data.tipoCartella);

    if (data.tipoCartella && data.tipoCartella != 0) {
      
      temp = temp.filter(x => x.idTipoEntrata == data.tipoCartella)
      console.log(temp)
      console.log("prova 2")
    }
    setPagamentiEffettuati(temp)

  };



  const handleChangeSelect = (event, nameOfComponent) => {
    let name = nameOfComponent.name;
    console.log('name: ', name);
    let value = event.value;
    console.log('value: ', value);

    switch (name) {
      case "valueDataEntry":
        setAdvancedFilters(false)
        if (value == "DalAl") {
          setAdvancedFilters(true)
        } else {
          var startdate = moment();
          switch (value) {
            case "1m":
              startdate = moment()
                .subtract(1, "months")
                .format("YYYY/MM/DD");
              break;
            case "3m":
              startdate = moment()
                .subtract(3, "months")
                .format("YYYY/MM/DD");
              break;
            case "1y":
              startdate = moment()
                .subtract(1, "years")
                .format("YYYY/MM/DD");
              break;

          }
          setData((prevState) => ({
            ...prevState,
            dal: startdate,
            al: moment().format("YYYY/MM/DD"),
          }));
        }

        break;

      case "annoEmmisione":
        setData((prevState) => ({
          ...prevState,
          AnnoEmissione: event.value,
        }));
        break;

      case "typeEntry":
        setData((prevState) => ({
          ...prevState,
          tipoCartella: event.value,
        }));
        break;




      default:
        break;
    }
  };


  const setFilter = (responseElements) => {

    if (responseElements && responseElements.length > 0) {
      var arrayUniqueByKey = [

        ...new Map(
          responseElements.map((item) => [
            item["idTipoEntrata"],
            item["tipoEntrata"]
          ])
        ),
      ];


      var listElementEntrys = [
        {
          value: "0",
          label: "Tutti",
        },
        {
          value: "1",
          label: "1",
        },
      ];



      arrayUniqueByKey.map((x) => {

        // if (!itemsInError.includes(x[0])) {

        listElementEntrys.push({
          value: x[0],
          label: x[1],
        });
        // }

      });

      setEntrysList(listElementEntrys);


    }
  };

  const setDataAvanceFilter = (e) => {
    e.preventDefault()
    var tempData = data
    switch (e.target.name) {
      case "dateStart":
        tempData.dal = e.target.value
        setData(tempData)
        break;

      case "dataEnd":
        tempData.al = e.target.value
        setData(tempData)

        break;
    }

    console.log("dd", data)
  }



  return (
    <>
      <div className="clearfix">
        <div className="float-left">
          <nav className="breadcrumb-container pl-2" aria-label="breadcrumb">
            <ol className="breadcrumb">
              <Link
                style={{ color: "inherit", textDecoration: "inherit" }}
                to={"/"}
              >
                Home
              </Link>
              &nbsp; <b>/</b>
              <a className={"breadcrumb-item active"}>
                &nbsp; <b>Pagamenti Effettuati</b> &nbsp;
              </a>{" "}
            </ol>
          </nav>
        </div>
      </div>

      {errorMessage && <AlertMessage error={true}></AlertMessage>}

      <div className="col-12">
        <div className="card card-teaser rounded shadow mb-2">
          <div className="card-body">
            <h3>Dettaglio Pagamenti Effettuati</h3>
            <br />

            <form onSubmit={handleSubmit}>
              <div>
                <div className="form-row">
                  <div className=" col-6">
                    <div className="bootstrap-select-wrapper">
                      <label>Periodo</label>

                      <Select
                        aria-label="Scegli una opzione"
                        name="valueDataEntry"
                        defaultInputValue=""
                        defaultMenuIsOpen={false}
                        defaultValue={null}
                        icon={false}
                        onChange={handleChangeSelect}
                        options={[
                          {
                            value: "1m",
                            label: "Ultimo mese",
                          },
                          {
                            value: "3m",
                            label: "Ultimi tre mesi",
                          },
                          {
                            value: "1y",
                            label: "Ultimo anno",
                          },
                          {
                            value: "DalAl",
                            label: "Atro Periodo",
                          },
                        ]}
                        placeholder="Scegli una opzione"
                      />
                    </div>
                  </div>

                  <div className="col-lg-4 mb-4">
                    <div className="bootstrap-select-wrapper">
                      <label>Tipo Entrata</label>
                      <Select
                        aria-label="Scegli una opzione"
                        clearText="Annulla"
                        // value={{ label: data.LabelEntrata, value: data.TipoEntrata }}
                        defaultMenuIsOpen={false}
                        icon={false}
                        name="typeEntry"
                        onChange={handleChangeSelect}
                        options={entrysList}
                        placeholder="Scegli una opzione"
                      />
                    </div>
                  </div>

                  <div className="col-2 text-center">
                    <button type="submit" className="btn btn-primary">
                      Cerca{" "}
                    </button>
                  </div>
                </div>

                {advancedFilters && <div className="form-row mt-4">
                  <div className=" col-6">
                    <Input
                      label="Data Inizio"
                      id="dateStart"
                      name="dateStart"
                      type="date"
                      placeholder=" "
                      onChange={setDataAvanceFilter}
                    />
                  </div>

                  <div className=" col-6">
                    <Input
                      label="Data Fine"
                      id="dataEnd"
                      name="dataEnd"
                      type="date"
                      placeholder=" "
                      onChange={setDataAvanceFilter}
                    />
                  </div>

                </div>}

              </div>
            </form>
          </div>
        </div>

        <div className="col-12 mt-5">
          {loading ? (
            <>
              {pagamentiEffettuati.length > 0 ? (
                <>
                  {" "}
                  <ListaPagamentiEffettuati>
                    {pagamentiEffettuati}
                  </ListaPagamentiEffettuati>
                </>
              ) : (
                <b>Nessun Risultato!</b>
              )}
            </>
          ) : (
            <div className="col-12">
              <div className="trasparente">
                <div className="progress-spinner progress-spinner-active spinner">
                  <span className="sr-only">Caricamento...</span>
                </div>
              </div>
            </div>
          )}

          {pagamentiEffettuati.length !== 0 && (
            <Pagination
              methodChange={ChangePage}
              PageIndex={pageNumber + 1}
              PageCount={pageCount}
              TotalCount={queryCount}
            ></Pagination>
          )}
        </div>
      </div>
    </>
  );
}

export default PagamentiEffettuati;
